<template>
  <div>
    <v-row class="mb-4">
      <Breadcrump :crumbs="crumbs" />
      <v-spacer />
    </v-row>

    <v-card>
      <CrudTable
        title="لیست انواع دستگاه"
        api="/device/devicetype"
        permissionPrefix="DeviceType"
      />
    </v-card>
  </div>
</template>
<script>
import Breadcrump from "@/components/common/Breadcrump.vue";
import CrudTable from "@/components/complex/CrudTable.vue";

export default {
  name: "ComplexSettings",
  components: {
    Breadcrump,
    CrudTable
  },
  data() {
    return {
      tab: 0,
      crumbs: [
        { text: "خانه", disabled: false, href: "/" },
        { text: "تنظیمات دستگاه", disabled: true }
      ]
    };
  }
};
</script>
